'use client';

import React, { useEffect, useState, useRef } from 'react';
import CountUp from 'react-countup';

export default function StatsSection() {
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasAnimated(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const stats = [
    { icon: 'bi-people-fill', end: 232, label: 'Manpower ', subtext: 'Deployed' },
    { icon: 'bi-journal-richtext', end: 521, label: 'Projects ', subtext: 'Completed' },
    { icon: 'bi-buildings-fill', end: 1453, label: 'Industries ', subtext: 'Served' },
    { icon: 'bi-journal-check', end: 32, label: 'Compliance ', subtext: 'Rate' },
  ];

  return (
    <section id="stats" className="stats section">
      <div className="container" data-aos="fade-up" data-aos-delay="100" ref={statsRef}>
        <div className="row gy-4 align-items-center justify-content-between">
          <div className="col-lg-5">
            <img src="/assets/img/nais-lOheaJEIrjI-unsplash.jpg" alt="Stats" className="img-fluid" />
          </div>

          <div className="col-lg-6">
            <h3 className="fw-bold fs-2 mb-3">Trusted by Businesses Across India</h3>
            <p>
               Our numbers speak for our commitment and quality in manpower services.
            </p>

            <div className="row gy-4">
              {stats.map((stat, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="stats-item d-flex">
                    <i className={`bi ${stat.icon} flex-shrink-0`}></i>
                    <div>
                      <span className="count display-6 fw-semibold">
                        {hasAnimated ? <CountUp start={0} end={stat.end} duration={1.5} /> : 0}
                      </span>
                      <p>
                        <strong>{stat.label}</strong> <span>{stat.subtext}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
